import { C } from '../lib/theme';
import { styles } from '../lib/styles';
import { BCID_APPROVED_REASONS_URL, UNSUCCESSFUL_REASONS } from '../domain/constants';

export function Settings() {
  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: C.text, marginBottom: 20 }}>Portal Settings</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={styles.card}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>External Links</h3>
          <div style={{ fontSize: 13, lineHeight: 2 }}>
            <div><a href={BCID_APPROVED_REASONS_URL} target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>BCID Approved Call Reasons List ↗</a></div>
            <div><a href="https://tmsearch.uspto.gov/search/search-information" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>USPTO TESS (Trademark Search) ↗</a></div>
            <div><a href="https://publicrecords.copyright.gov/" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>U.S. Copyright Office ↗</a></div>
            <div><a href="https://lookup.icann.org/en" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>ICANN Domain Lookup ↗</a></div>
            <div><a href="https://pcl.uscourts.gov/pcl/index.jsf" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>PACER (Legal Complaints) ↗</a></div>
            <div><a href="https://www.ftc.gov/legal-library/browse/cases-proceedings" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>FTC Case Search ↗</a></div>
            <div><a href="https://siccode.com/sic-code-lookup-directory" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>SIC Code Lookup ↗</a></div>
            <div><a href="https://api.ctia.org/wp-content/uploads/2022/11/Branded-Calling-Best-Practices.pdf" target="_blank" rel="noopener noreferrer" style={{ color: C.goldText }}>BCID Best Practices PDF ↗</a></div>
          </div>
        </div>
        <div style={styles.card}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>SLA Configuration</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            {[
              // #778 — one clock since #692: 382 is the OA and the VA on every case.
              ['Vetting SLA (from acceptance into vetting)', '15 business days'],
              ['Registrant notification deadline', '30 calendar days from decision'],
              ['Cure window', '12 business days'],
              ['Appeal reassessment period', '90 calendar days'],
              ['Re-vet response window', '10 calendar days'],
              ['Settlement Platform sync deadline', '24 hours from approved change'],
            ].map(([label, val], i) => (
              <div key={i}>
                <label style={{ fontSize: 11, color: C.textMuted, display: 'block', marginBottom: 4 }}>{label}</label>
                <input style={styles.input} value={val} readOnly />
              </div>
            ))}
          </div>
        </div>
        <div style={styles.card}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Unsuccessful Vet Reason Codes</h3>
          <div style={{ fontSize: 12, lineHeight: 2 }}>
            {UNSUCCESSFUL_REASONS.map((r, i) => <div key={i} style={{ padding: '4px 0', borderBottom: `1px solid ${C.border}` }}>{r}</div>)}
          </div>
        </div>
      </div>
    </div>
  );
}
